(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["av-smart-watering"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.querySelector('.section-{{ section.id }}');
  if (!section) return;

  const video = section.querySelector('video');
  const btn = section.querySelector('[data-av-video-toggle]');
  if (!video || !btn) return;

  btn.addEventListener('click', function() {

    // Ensure attributes are correct
    video.muted = false;        // Allow sound on interaction
    video.controls = true;      // Enable controls after play
    video.loop = true;

    const playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.then(function() {
        btn.style.display = 'none';
      }).catch(function(error) {
        console.error('Video failed to play:', error);
      });
    } else {
      btn.style.display = 'none';
    }

  });

})();

  } catch(e) { console.error(e); }
})();
})();
